// extracted by mini-css-extract-plugin
export default {"roadmap":"roadmap_roadmap__UtP1C","Accordion":"roadmap_Accordion__TFQDk","accordionItem":"roadmap_accordionItem__3IhZk","Header":"roadmap_Header__lMpy+","body":"roadmap_body__tML+O"};